import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MuiPaper from 'material-ui/Paper';
import MuiFlatButton from 'material-ui/FlatButton';
import MuiRaisedButton from 'material-ui/RaisedButton';
import MuiActionInfoOutline from 'material-ui/svg-icons/action/info-outline';
import styles from './styles';
import { scienceBlue } from '../../theme/colors';
import './index.css';

export default class ManualActivationStepThree extends Component {
  static propTypes = {
    moveForward: PropTypes.func,
    moveBackwards: PropTypes.func,
  }

  render() {
    return (
      <div className="activate-step-three">
        <MuiPaper style={ styles.paperStyle } zDepth={ 3 } className="activate-step-paper">
          <div className="activate-step-content">
            <p><span className="semibold">Step 3.</span> Congrats! Start using your machine to make sure it's activated.</p>
            <div className="activate-step-instructions">
              <p><span className="semibold">For treadmills:</span> Press the Start button. Once your treadmill belt starts moving, you've successfully activated your machine.</p>
              <p><span className="semibold">For bikes, ellipticals, and other smart equipment:</span> Once you see metrics appear on your console, you've successfully activated your machine.</p>
            </div>
          </div>

          <div className="activate-step-buttons clearfix">
            <MuiFlatButton
              className="activate-step-prev"
              label="Previous"
              labelStyle={ styles.prevLabelStyle }
              hoverColor="transparent"
              rippleColor="transparent"
              style={ styles.flatButtonStyle }
              onClick={ this.props.moveBackwards }
            />
            <MuiRaisedButton
              className="activate-step-try"
              label="Done"
              primary={ true }
              onClick={ this.props.moveForward }
            />
          </div>

          <div className="activate-step-tooltip">
            <MuiActionInfoOutline color={ scienceBlue } />
            <p>Having issues?<br />
            Try repeating Step 1 and Step 2</p>
          </div>
        </MuiPaper>
      </div>
    );
  }
}
